import React from "react";
import {
  SiteNavigationElementSchema,
  FoodEstablishmentSchema,
  MessageDisplay,
  SiteNavigation,
  HoursOfOperation,
  RecaptchaProvider,
  Footer,
  Location,
  Image,
  SiteMap,
  CopyrightLabel,
  OutboundLink,
  FishermanBanner,
} from "@bluefin/components";
import { Header } from "semantic-ui-react";
import { graphql, StaticQuery } from "gatsby";

import {
  getComponentFiles,
  filterRegularLinks,
  filterButtonLinks,
} from "../utils/utils";
import "../semantic/semantic.less";
import "../style/WebsiteLayout.css";

export default ({ children }) => (
  <StaticQuery
    query={graphql`
      query {
        allFishermanBusinessWebsitePage(
          sort: { order: ASC, fields: navigationPriority }
        ) {
          nodes {
            slug
            description
            title
            pageType
            url
            navigationPriority
            groupName
            props
          }
        }
        fishermanBusiness {
          name
          type
          logo
          menu {
            schedules {
              availableDays
              categories
              _id
              name
            }
            categories {
              items
              name
              _id
            }
            items {
              modifierSets
              description
              _id
              name
              variations {
                _id
                menuItem
                name
                order
                price
              }
            }
            modifierSets {
              _id
              minAllowed
              modifiers
              name
            }
            modifiers {
              _id
              name
              price
            }
          }
          primaryLocation {
            timezone
            hours {
              day
              open
              close
              label
            }
            phoneNumber
            email
            street
            city
            state
            zipCode
          }
          gatsbyLogo {
            childImageSharp {
              gatsbyImageData(layout: FIXED, height: 60)
            }
          }
        }
        allFishermanBusinessLocation {
          nodes {
            street
            city
            state
            zipCode
            country
            email
            phoneNumber
            name
            hours {
              open
              close
              day
            }
          }
        }
        fishermanBusinessWebsitePage(pageType: { eq: "Home" }) {
          components {
            fastId
            componentIdentifier
            order
            files {
              file
              gatsbyFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH)
                }
              }
            }
          }
        }
        fishermanWebsiteComponent(
          layout: { name: { eq: "@" } }
          fastId: { eq: "MessageDisplay" }
        ) {
          data {
            subject
            content
            startTime
            endTime
            modalDelay
            bannerBackgroundColor
          }
        }
      }
    `}
    render={(data) => {
      const {
        allFishermanBusinessWebsitePage,
        fishermanBusiness,
        allFishermanBusinessLocation,
        fishermanBusinessWebsitePage,
        fishermanWebsiteComponent,
      } = data;

      return (
        <React.Fragment>
          <SiteNavigationElementSchema
            pages={allFishermanBusinessWebsitePage.nodes}
            siteUrl={"https://ghqgroomingformen.com"}
          />
          <FoodEstablishmentSchema
            name={fishermanBusiness.name}
            siteUrl={"https://ghqgroomingformen.com"}
            businessType={fishermanBusiness.type}
            logo={fishermanBusiness.logo}
            address={allFishermanBusinessLocation.nodes}
            menu={fishermanBusiness.menu}
            images={getComponentFiles({
              components: fishermanBusinessWebsitePage.components,
              componentName: "HeroElement",
              numToSelect: 1,
            })}
          />
          <div className={"site-container"}>
            <div>
              <MessageDisplay
                subject={fishermanWebsiteComponent.data.subject}
                content={fishermanWebsiteComponent.data.content}
                businessName={fishermanBusiness.name}
                startTime={fishermanWebsiteComponent.data.startTime}
                endTime={fishermanWebsiteComponent.data.endTime}
                modalDelay={fishermanWebsiteComponent.data.modalDelay}
                bannerBackgroundColor={
                  fishermanWebsiteComponent.data.bannerBackgroundColor
                }
                timezone={fishermanBusiness.primaryLocation.timezone}
              />
              <SiteNavigation widths={3}>
                <SiteNavigation.Menu position={"left"}>
                  <SiteNavigation.Links
                    links={filterRegularLinks({
                      links: allFishermanBusinessWebsitePage.nodes,
                    })}
                  />
                </SiteNavigation.Menu>
                <SiteNavigation.Logo
                  title={<Header as={"h3"}>{fishermanBusiness.name}</Header>}
                  src={fishermanBusiness.gatsbyLogo.childImageSharp}
                />
                <SiteNavigation.Menu position={"right"}>
                  <SiteNavigation.Item position={"right"}>
                    <HoursOfOperation
                      timezone={fishermanBusiness.primaryLocation.timezone}
                      hours={fishermanBusiness.primaryLocation.hours}
                      displayOption={"dailyWithPopup"}
                      displayOpenClosedStatus={true}
                    />
                  </SiteNavigation.Item>
                  <SiteNavigation.Links
                    links={filterButtonLinks({
                      links: allFishermanBusinessWebsitePage.nodes,
                    })}
                  />
                </SiteNavigation.Menu>
              </SiteNavigation>
            </div>
            <RecaptchaProvider>
              <div className={"page-container"}>{children}</div>
              <Footer
                backgroundColor={"primary"}
                horizontalAlign={"center"}
                verticalAlign={"middle"}
                columns={[
                  <Location
                    businessName={fishermanBusiness.name}
                    phone={fishermanBusiness.primaryLocation.phoneNumber}
                    email={fishermanBusiness.primaryLocation.email}
                    address={{
                      street: fishermanBusiness.primaryLocation.street,
                      city: fishermanBusiness.primaryLocation.city,
                      state: fishermanBusiness.primaryLocation.state,
                      zip: fishermanBusiness.primaryLocation.zipCode,
                    }}
                  />,
                  <div>
                    <Image src={fishermanBusiness.gatsbyLogo.childImageSharp} />
                    <SiteMap
                      links={allFishermanBusinessWebsitePage.nodes}
                      horizontal={true}
                      bulleted={false}
                    />
                    <CopyrightLabel
                      company={fishermanBusiness.name}
                      phrase={"All Rights Reserved"}
                      privacyPolicyLink={
                        <OutboundLink
                          to={
                            "https://fisherman-static.s3.amazonaws.com/public/__fisherman/Client+Website+Privacy+Policy.pdf"
                          }
                          label={"Privacy Policy"}
                          eventLabel={"copyright-privacy-policy"}
                        />
                      }
                    />
                  </div>,
                  <HoursOfOperation
                    hours={fishermanBusiness.primaryLocation.hours}
                    displayOption={"grouped"}
                  />,
                ]}
              />
            </RecaptchaProvider>
          </div>
          <FishermanBanner />
        </React.Fragment>
      );
    }}
  />
);
